import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Switch from '@mui/material/Switch';
import WifiIcon from '@mui/icons-material/Wifi';
import BluetoothIcon from '@mui/icons-material/Bluetooth';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/List": List, "@mui/material/ListItem": ListItem, "@mui/material/ListItemIcon": ListItemIcon, "@mui/material/ListItemText": ListItemText, "@mui/material/ListSubheader": ListSubheader, "@mui/material/Switch": Switch, "@mui/icons-material/Wifi": WifiIcon, "@mui/icons-material/Bluetooth": BluetoothIcon } } });
export default ClientProvider;
